import { render } from "./TeamPhoto.vue?vue&type=template&id=63a419f9"
import script from "./TeamPhoto.vue?vue&type=script&lang=js"
export * from "./TeamPhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__